<app-header></app-header>

<div class="container login-component mt-46 overflow-visible">
  <div class="ng-row" justify-content-center>
    <div class="ng-col">
      <app-steps stepHeading="AccountRegistration" stepCounter="1"></app-steps>
    </div>
    <div class="ng-col pt-20 pd-sm-30" col-6 col-sm-12>
      <div class="font-30 color-010 font-600 mt-5 text-align-center mt-30">
        {{ "MobileNumber" | translate }}
      </div>

      <div class="font-14 color-354 font-300 mt-5 text-align-center">
        {{ "Mobileregister" | translate }}
      </div>

      <div class="mt-42 mb-42">
        <form [formGroup]="mobileform">
          <!-- id='textboxes' (keydown)="Enter($event)" -->
          <div class="form-group mt-30">
            <label>{{ "Mobile Number" | translate }}</label>
            <div class="ng-row">
              <div class="ng-col" col-3 col-sm-4>
                <app-drop-down-list
                  dropDownImage="true"
                  dropDownSearch="true"
                  [selectedIcon]="this.selectedCountryIcon"
                  [selectedValue]="this.selectedCurrentCountry"
                  [dropDownData]="this.dropdownlist"
                  (itemselected)="onCountryChange($event)"
                  dropDownPlaceholder="92"
                  class="disabled"
                >
                </app-drop-down-list>
                <!-- <input type="tel" value="+92" readonly> -->
              </div>
              <div class="ng-col pl-10" col-9 col-sm-8>
                <input
                  type="tel"
                  value=""
                  [placeholder]="this.numberPlaceHolder"
                  [mask]="this.numberPlaceHolder"
                  [(ngModel)]="mobilenumber"
                  pattern="[0-9]*"
                  formControlName="mobile"
                  [maxlength]="this.mobilemaxlength"
                  [minlength]="this.mobileminlength"
                  (keypress)="Enterkey($event)"
                />
                <div class="error-label" *ngIf="this.max == true">
                  {{ "MobileMax" | translate }}
                </div>
                <ng-container
                  item-content
                  *ngFor="
                    let validation of errorkey.validation_messages.mobilenumber
                  "
                >
                  <div
                    class="error-label"
                    *ngIf="
                      mobileform.controls.mobile.hasError(validation.type) &&
                      mobileform.controls.mobile.touched
                    "
                  >
                    {{ getMessage(validation.key, "mobilenumber") }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="mt-30 text-align-center" *ngIf="this.siteKey">
            <recaptcha
              class="display-inline-block"
              [size]="'normal'"
              [sitekey]="this.siteKey"
              formControlName="recaptcha"
              [hide]="false"
              (captchaExpired)="onCaptchaExpired()"
              (captchaResponse)="onCaptchaResponse($event)"
            >
            </recaptcha>
          </div>
        </form>
      </div>

      <div class="form-group mt-30 mb-30">
        <button
          class="btn-dft"
          (click)="VerifyMobilebNumber()"
          [disabled]="IsFormValid()"
        >
          {{ "Login" | translate }}
        </button>

        <!-- <button class="btn-dft mt-15" [routerLink]="['/register/W9FormMatchName']">
          {{"W9 Form" | translate}}
        </button>
        
         -->

        <!-- <button class="btn-dft mt-15" [routerLink]="['/register/SelectAgent']">
          {{"Select agent" | translate}}
        </button> -->
        <!-- <button class="btn-dft mt-15" [routerLink]="['/register/ApplicationSubmitted']">
          {{"Application Submitted" | translate}}
        </button> -->
      </div>
    </div>
  </div>
</div>
